import React from 'react';
import Button from '../../../components/ui/Button';

const CalendarHeader = ({ 
  currentDate, 
  currentView, 
  onViewChange, 
  onDateNavigation, 
  onToday,
  onYearNavigation
}) => {
  const formatCurrentDate = () => {
    if (currentView === 'month') {
      return currentDate?.toLocaleDateString('pt-BR', {
        month: 'long',
        year: 'numeric'
      });
    } else {
      const startOfWeek = new Date(currentDate);
      startOfWeek?.setDate(currentDate?.getDate() - currentDate?.getDay());
      const endOfWeek = new Date(startOfWeek);
      endOfWeek?.setDate(startOfWeek?.getDate() + 6);
      
      if (startOfWeek?.getMonth() === endOfWeek?.getMonth()) {
        return `${startOfWeek?.getDate()} - ${endOfWeek?.getDate()} de ${startOfWeek?.toLocaleDateString('pt-BR', {
          month: 'long',
          year: 'numeric'
        })}`;
      } else {
        return `${startOfWeek?.toLocaleDateString('pt-BR', {
          day: 'numeric',
          month: 'short'
        })} - ${endOfWeek?.toLocaleDateString('pt-BR', {
          day: 'numeric',
          month: 'short',
          year: 'numeric'
        })}`;
      }
    }
  };

  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 bg-card border border-border rounded-lg p-4 shadow-tier-1">
      {/* Date Navigation */}
      <div className="flex items-center space-x-4">
        <div className="flex items-center space-x-2">
          <Button
            variant="outline"
            size="icon"
            iconName="ChevronLeft"
            onClick={() => onDateNavigation(-1)}
            aria-label="Período anterior"
          />
          <Button
            variant="outline"
            size="icon"
            iconName="ChevronRight"
            onClick={() => onDateNavigation(1)}
            aria-label="Próximo período"
          />
        </div>
        
        {/* Year Navigation */}
        <div className="flex items-center space-x-2">
          <Button
            variant="outline"
            size="icon"
            iconName="ChevronLeft"
            onClick={() => onYearNavigation(-1)}
            aria-label="Ano anterior"
          />
          <span className="text-sm font-medium text-muted-foreground px-2">
            {currentDate?.getFullYear()}
          </span>
          <Button
            variant="outline"
            size="icon"
            iconName="ChevronRight"
            onClick={() => onYearNavigation(1)}
            aria-label="Próximo ano"
          />
        </div>
        
        <div className="flex items-center space-x-3">
          <h2 className="text-lg font-semibold text-foreground capitalize">
            {formatCurrentDate()}
          </h2>
          <Button
            variant="ghost"
            size="sm"
            onClick={onToday}
            className="text-primary hover:text-primary/80"
          >
            Hoje
          </Button>
        </div>
      </div>

      {/* View Controls and Actions */}
      <div className="flex items-center space-x-3">
        {/* View Switcher */}
        <div className="flex items-center bg-background border border-border rounded-md">
          <Button
            variant={currentView === 'week' ? 'default' : 'ghost'}
            size="sm"
            onClick={() => onViewChange('week')}
            className="rounded-r-none border-r border-border"
          >
            Semana
          </Button>
          <Button
            variant={currentView === 'month' ? 'default' : 'ghost'}
            size="sm"
            onClick={() => onViewChange('month')}
            className="rounded-l-none"
          >
            Mês
          </Button>
        </div>

        {/* Additional Actions */}
        <div className="flex items-center space-x-2">
          <Button
            variant="outline"
            size="sm"
            iconName="Settings"
            iconPosition="left"
            iconSize={14}
          >
            Configurar
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CalendarHeader;